export default __webpack_public_path__ + "static/media/communication.450373d9.svg";